/**
 * ProtectedRoute — JWT auth majburiy bo'lgan sahifalar uchun
 *
 * Logika:
 *   1. Auth store'dan isAuthenticated tekshirish (token + payload + expiry)
 *   2. Token yo'q yoki muddati tugagan → /login ga redirect
 *   3. Token bor → child <Outlet />
 */

import { Navigate, Outlet, useLocation } from 'react-router';

import { useIsAuthenticated } from '@/features/auth/auth.hooks';

export function ProtectedRoute(): React.ReactElement {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect after login uchun joriy joyni saqlash
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
}
